import { createSlice } from "@reduxjs/toolkit";

import { login } from "./authActions";

const initialState = {
    isAuthenticated: false,
    initialized: false,
    loading: false,
    error: null
};

const authSlice = createSlice({
    name: "auth",

    initialState,

    reducers: {
        resetAuth(state) {
            state.isAuthenticated = false;
            state.loading = false;
            state.error = null;
        },

        setInitialized(state, action) {
            state.initialized = action.payload;
        },

        setAuthenticated(state, action) {
            state.isAuthenticated = action.payload;
        }
    },

    extraReducers: (builder) => {
        builder
            .addCase(login.pending, (state) => {
                state.loading = true;
                state.error = null;
            })

            .addCase(login.fulfilled, (state) => {
                state.loading = false;
                state.isAuthenticated = true;
            })

            .addCase(login.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { resetAuth, setInitialized, setAuthenticated } =
    authSlice.actions;

export default authSlice.reducer;
